<template>
    <div>
        <Dialog :showHeader="false" position="top" :visible.sync="dialogConfig" :closeOnEscape="true"
        :closable="false" :modal="false" :style="{ width: '95vw' }" class="border-round">
            <config-mil @closeDialogConfig="dialogConfig = false"></config-mil>
        </Dialog>

        <div class="card">
            <div class="flex card-container blue-container overflow-hidden">
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined" @click="cierraVentana()" v-tooltip.right="'Cerrar'" />
                </div>
                <h1 class="flex-grow-1 flex align-items-center justify-content-center py-2">Configuración Capítulo 1000</h1>
            </div>
            <hr size=7 color="#FF6699">
        </div>
        <div class="card">
            <DataTable :value="listaPuestoDepartamento" :scrollable="true" scrollHeight="600px" scrollDirection="both" :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown":rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" :loading="loading" :filters.sync="filtros" :selection.sync="selectedPuestos" dataKey="puesto">
                <template #header>
                    <div class="flex justify-content-center flex-wrap card-container">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText v-model="filtros['global'].value" placeholder="Buscar" />
                        </span>
                    </div>
                </template>

                <Column selectionMode="multiple" :styles="{'width':'1rem', 'min-width':'3rem'}"></Column>

                <Column header="Acciones" :styles="{'width':'1rem', 'min-width':'5rem'}" :exportable="false">
                    <template #body="slotProps">
                        <Button icon="mdi mdi-cog" class="p-button-text p-button-rounded" v-tooltip.bottom="'Configurar'" @click="OpenDialogConfig()" />
                    </template>
                </Column>

                <Column field="puesto" header="Puesto" :styles="{'width':'100rem'}">
                </Column>
            </DataTable>
        </div>
    </div>
    </template>
    <script>
        import axios from 'axios'
        import moment from 'moment'
        import { FilterMatchMode, FilterOperator } from "primevue/api/";
        import configMil from './ReporteMilConfigCapitulo.vue'

        export default {
            components: {
                configMil,
            },
            data() {
                return {
                    fechaI: new Date(),
                    fechaF: new Date(),
                    listaPuestoDepartamento:[],
                    loading: false,
                    dialogConfig: false,
                    filtros: {
                        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    },
                    selectedPuestos: [],
                    value1: null,
                }
            },
            computed: {
                token() {
                    return this.$store.state.usuario;
                },
                
            },
            created() {
                this.GetPuestoDepartamento();
            },

            methods: {
                formatCurrency(value) {
                    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
                },
    
                formtaDate(value){
                    return moment(value).format('DD-MM-YYYY')
                },

                async GetPuestoDepartamento(){
                    try{
                        this.loading = true;
                        let response =  await axios.get('ReporteNominas/GetPuestoMil/'+ this.token.empresaBase);
                        let x = response.data;
                        this.listaPuestoDepartamento = x;
                        this.loading = false;
                    }catch(error){
                        console.log(error);
                        this.loading = false;
                    }
                },

                OpenDialogConfig(){
                    if(this.selectedPuestos.length == 0){
                        return
                    }
                    this.$store.state.listPuestosStore = [ ...this.selectedPuestos ]
                    this.dialogConfig = true;
                    console.log(this.$store.state.listPuestosStore)
                },

                cierraVentana(){
                    this.$emit('closeDialogConfig')
                },
    
            },
        }
    </script>